import React, { useEffect } from 'react'
import { useDesignStore } from '../../store/designStore'
import { useDragControls } from '../../hooks/useDragControls'
import ADUModel from './models/ADUModel'
import ADUModularModel from './models/ADUModularModel'
import PoolModel from './models/PoolModel'
import PoolEquipmentModel from './models/PoolEquipmentModel'
import ADUEquipmentModel from './models/ADUEquipmentModel'
import ADUInteriorView from './ADUInteriorView'

interface DesignedObjectsProps {
  showInteriorView?: boolean
}

const DesignedObjects: React.FC<DesignedObjectsProps> = ({ showInteriorView = false }) => {
  const { aduModels, poolModels, poolEquipment, aduEquipment, selectedObjects, selectObject } = useDesignStore()
  const { handlePointerDown, attachEventListeners, isDragging, draggedObjectId } = useDragControls()

  useEffect(() => {
    const cleanup = attachEventListeners()
    return cleanup
  }, [attachEventListeners])

  const handleObjectClick = (id: string) => {
    if (!isDragging) {
      selectObject(id)
    }
  }

  const handleObjectPointerDown = (event: any, id: string) => {
    event.stopPropagation()
    handlePointerDown(event.nativeEvent, id)
  }

  const isSelected = (id: string) => {
    return selectedObjects.some(obj => obj.id === id)
  }

  const isDraggingObject = (id: string) => {
    return isDragging && draggedObjectId === id
  }

  return (
    <>
      {aduModels.map((adu) => (
        <React.Fragment key={adu.id}>
          {showInteriorView ? (
            <ADUInteriorView adu={adu} />
          ) : adu.isModular ? (
            <ADUModularModel 
              adu={adu}
              isSelected={isSelected(adu.id)}
              onClick={() => handleObjectClick(adu.id)}
              onPointerDown={(event) => handleObjectPointerDown(event, adu.id)}
              isDragging={isDraggingObject(adu.id)}
            />
          ) : (
            <ADUModel 
              {...adu} 
              isSelected={isSelected(adu.id)}
              onClick={() => handleObjectClick(adu.id)}
              onPointerDown={(event) => handleObjectPointerDown(event, adu.id)}
              isDragging={isDraggingObject(adu.id)}
            />
          )}
        </React.Fragment>
      ))}
      {poolModels.map((pool) => (
        <PoolModel 
          key={pool.id} 
          {...pool} 
          isSelected={isSelected(pool.id)}
          onClick={() => handleObjectClick(pool.id)}
          onPointerDown={(event) => handleObjectPointerDown(event, pool.id)}
          isDragging={isDraggingObject(pool.id)}
        />
      ))}
      {poolEquipment.map((equipment) => (
        <PoolEquipmentModel 
          key={equipment.id} 
          {...equipment} 
          isSelected={isSelected(equipment.id)}
          onClick={() => handleObjectClick(equipment.id)}
          onPointerDown={(event) => handleObjectPointerDown(event, equipment.id)}
          isDragging={isDraggingObject(equipment.id)}
        />
      ))}
      {aduEquipment.map((equipment) => (
        <ADUEquipmentModel 
          key={equipment.id} 
          {...equipment} 
          isSelected={isSelected(equipment.id)}
          onClick={() => handleObjectClick(equipment.id)}
          onPointerDown={(event) => handleObjectPointerDown(event, equipment.id)}
          isDragging={isDraggingObject(equipment.id)}
        />
      ))}
    </>
  )
}

export default DesignedObjects